import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

class MyQuoteButton extends Component {
  render () {
    const { text, quoteId } = _.clone(this.props);
    return <Link to={'/quote/' + quoteId}>
      <button className={'btn alt'}>{text}</button>
    </Link>;
  }
}

export default MyQuoteButton;
